import { FC } from 'react';
import { Bid } from 'src/api/auctionApi';
import { MuiModal } from 'src/components/material/MuiModal';
import { BidResult } from '../BidInfo/BidResultEnum';
import { Header } from './Header/Header';
import { SubInfo } from './SubInfo/SubInfo';
import { TotalDue } from './TotalDue/TotalDue';

interface JoinModalProps {
  isOpenModal: boolean;
  setIsOpenModal: (open: boolean) => void;
  leader_name?: string;
  tribe_name?: string;
  tribe_avatar_url?: string;
  price?: number;
  open_seat_count?: number;
  closeDate?: string;
  existingBid?: Bid | undefined | null;
  bidResult?: BidResult | null;
  onRefreshAuctionData: () => void;
}

export const JoinModal: FC<JoinModalProps> = ({
  isOpenModal,
  setIsOpenModal,
  leader_name,
  tribe_name,
  tribe_avatar_url,
  price,
  open_seat_count,
  closeDate,
  existingBid,
  bidResult,
  onRefreshAuctionData,
}) => {
  return (
    <MuiModal open={isOpenModal} setOpen={setIsOpenModal}>
      <Header
        leader_name={leader_name}
        tribe_name={tribe_name}
        tribe_avatar_url={tribe_avatar_url}
        price={price}
      />
      <SubInfo open_seat_count={open_seat_count} closeDate={closeDate} />
      <TotalDue
        price={price}
        existingBid={existingBid}
        closeDate={closeDate}
        bidResult={bidResult}
        onRefreshAuctionData={onRefreshAuctionData}
      />
    </MuiModal>
  );
};
